import { render } from "./CasesPage.vue?vue&type=template&id=939d3724&ts=true"
import script from "./CasesPage.vue?vue&type=script&lang=ts"
export * from "./CasesPage.vue?vue&type=script&lang=ts"

import "./CasesPage.vue?vue&type=style&index=0&id=939d3724&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__